import Router from 'next/router';

import axios from 'Services/axios';
import { ACCESS_RESTRICTED_BLOCKED_DEALER } from 'Utilities/fetch.helpers';

import ROUTES from '../routes';

export const routeToHomepageIfUserBlockedFromAPI = async (apiPath) => {
	try {
		await axios.get(apiPath);
	} catch (err) {
		if (err?.response?.data?.code === ACCESS_RESTRICTED_BLOCKED_DEALER) {
			await Router.replace(ROUTES.INDEX.href);
		}
	}
};
